<template>
  <div>
    <div class="search-wrapper">
      <span>标题：</span>
      <Input style="width:200px;margin-right:20px;" type="text" v-model="searchValue.WorkflowTitle"></Input>
      <span>创建人：</span>
      <Input style="width:150px;margin-right:20px;" type="text" v-model="searchValue.CreatorRealName"></Input>
      <Button type="primary" @click="search" style="margin:5px 10px;">查询</Button>
      <Button type="primary" @click="$refs.flow.newFlow()">发起新流程</Button>
      <span style="margin-left:10%"  v-show="kind !== 'todo'">
        <RadioGroup v-model="flowStatus" type="button" @on-change="statusChange">
          <Radio :label="1" v-show="kind !== 'scan'">待办</Radio>
          <Radio :label="2">进行中</Radio>
          <Radio :label="3">完成</Radio>
          <Radio :label="4">经办(进行)</Radio>
          <Radio :label="5">经办(完成)</Radio>
        </RadioGroup>
        <Button
          type="success"
          size="small"
          slot="extra"
          @click="$emit('return',false)"
          style="margin-left:16px;"
          v-show="!kind"
        >返回上一页</Button>
      </span>
    </div>
    <Table
      :columns="columns"
      :data="formData"
      style="min-width:1100px"
    ></Table>
    <Page
      :total="pageTotal"
      :current="currentPage"
      show-elevator
      show-total
      style="margin-top:5px;"
      @on-change="pageChange"
    ></Page>
    <Flow-list
      :flowType="flowType"
      ref="flow"
      v-show="false"
      @dataFilter="dataFilter"
    ></Flow-list>
    <!-- 流程审批选择 -->
    <flowBranch
      :visible="branchVisible"
      :branchList="flowBranch"
      @visibleChange="visibleChange"
      @branchChoose="branchChoose"
      :branchType="branchType"
      ref="flowBranch"
    ></flowBranch>
    <!-- 操作按钮弹窗 -->
    <Modal
      class-name="formModal"
      v-model="formModal"
      :width="modalWidth"
      :mask-closable="false"
      :title="modalTitle"
    >
      <div
        v-show="modalTitle==='报表数据'"
        class="report">
        <div v-if="flowType === 'QR'">
          <commissionDeclareExtra
            :flowDetail="flowExtraInfo"
            :flowLine="flowLine"
            flowPosition="flowTable"
          ></commissionDeclareExtra>
        </div>
        <div v-if="flowType === 'ZJQR'">
          <commissionDeclareZJ
            :flowDetail="flowExtraInfo"
            :flowLine="flowLine"
            flowPosition="flowTable"
          ></commissionDeclareZJ>
        </div>
        <div v-if="flowType === 'ZXQR'">
          <commissionDeclareZX
            :flowDetail="flowExtraInfo"
            :flowLine="flowLine"
            flowPosition="flowTable"
          ></commissionDeclareZX>
        </div>
        <div v-if="flowType === 'FQ'">
          <commissionOldDeclareExtra
            :flowDetail="flowExtraInfo"
            :flowLine="flowLine"
            flowPosition="flowTable"
          ></commissionOldDeclareExtra>
        </div>
        <div v-if="flowType === 'FP'">
          <commissionGrantExtra :flowDetail="flowExtraInfo" flowPosition="flowTable"></commissionGrantExtra>
        </div>
      </div>
      <div v-show="modalTitle==='流程记录'">
        <Table
          :columns="flowColumns"
          :data="flowData"
        ></Table>
      </div>
      <!-- <div v-show="modalTitle==='退回原因'">
        <Input v-model="rejectOpinion" autofocus></Input>
      </div> -->
      <div v-show="modalTitle==='流程人员选择'">
        <flowNext
          :child-msg="flowPeople"
          @toparentevent="handleFlowNext"
        ></flowNext>
      </div>
      <div
        slot="footer"
        v-show="modalTitle==='退回原因'"
      >
        <Button @click="formModal=false">取消</Button>
        <Button
          type="primary"
          @click="rejectFlowConfirm"
        >确定</Button>
      </div>
      <div
        slot="footer"
        v-show="modalTitle==='流程人员选择'"
      >
        <Button @click="formModal=false">取消</Button>
        <Button
          @click="nextFlow"
          type="primary"
        >确定</Button>
      </div>
    </Modal>
    <!-- 报表显示 -->
    <!-- <Modal
      class-name="formDetail"
      width="98%"
      height="95%"
      v-model="formDetail"
      :title="formTitle"
    >
      <iframe
        style="width:100%;height:700px;border:0;"
        :src="functionUrl"
      ></iframe>
      <div slot="footer"></div>
    </Modal> -->
  </div>
</template>

<script>
import { getToDoList, getMyWorkItem, approvalFlow, getActivityUsers, deliverFlow, getFlowHistory, rejectFlow, getRejectActivityUsers, endFlow, getGetDoneList } from '@/lib/flow'
import { formatDate } from '@/lib/tool'
import FlowList from '@/components/flow/flowList'
import FlowNext from '@/components/flow/flowNext'
import FlowBranch from '@/components/flow/flowBranch'
import commissionDeclareExtra from '@/components/flow/extraInfo/commissionDeclareExtra'
import commissionDeclareZJ from '@/components/flow/extraInfo/commissionDeclareZJ'
import commissionDeclareZX from '@/components/flow/extraInfo/commissionDeclareZX'
import commissionGrantExtra from '@/components/flow/extraInfo/commissionGrantExtra'
import commissionOldDeclareExtra from '@/components/flow/extraInfo/commissionOldDeclareExtra'
import axios from 'axios'
import ajax from '@/lib/ajax'
import sendMessage from '@/lib/message'

export default {
  props: {
    type: String,
    kind: String
  },
  components: {
    FlowList,
    FlowNext,
    FlowBranch,
    commissionDeclareExtra,
    commissionGrantExtra,
    commissionOldDeclareExtra,
    commissionDeclareZJ,
    commissionDeclareZX
  },
  data() {
    return {
      user: {},
      searchValue: {
        WorkflowTitle: '',
        CreatorRealName: '',
        OpenBizDate: ''
      },
      columns: [
        {
          title: '流程单号',
          width: 150,
          key: 'SheetId'
        },
        {
          title: '标题',
          key: 'WorkflowTitle',
          align: 'center'
        },
        {
          title: '创建人',
          width: 80,
          key: 'CreatorRealName',
          align: 'center'
        },
        // {
        //   title: '创建时间',
        //   width: 110,
        //   key: 'CreatedTime',
        //   align: 'center',
        //   render: (h, params) => {
        //     // return h('span', this.$options.filters.filterTime(params.row.CreatedTime))
        //     return h('span', params.row.OpenBizDate)
        //   }
        // },
        {
          title: '提成月份',
          width: 110,
          align: 'center',
          render: (h, params) => {
            // return h('span', this.$options.filters.filterTime(params.row.CreatedTime))
            const flowInfo = JSON.parse(params.row.BusinessKey)
            let time = '未选择'
            if (flowInfo && flowInfo.time) {
              time = formatDate(flowInfo.time, 'miniCN')
            }
            return h('span', time)
          }
        },
        {
          title: '分子公司',
          width: 190,
          align: 'center',
          render: (h, params) => {
            // return h('span', this.$options.filters.filterTime(params.row.CreatedTime))
            const flowInfo = JSON.parse(params.row.BusinessKey)
            let companyName = '未选择'
            if (flowInfo && flowInfo.company) {
              companyName = flowInfo.company
            }
            return h('span', companyName)
          }
        },
        {
          title: '流程状态',
          width: 85,
          key: 'WorkflowInstanceState',
          align: 'center',
          render: (h, params) => {
            switch (params.row.WorkflowInstanceState) {
              case 3:
                return h('div', '成功')
                break
              case 5:
                return h('div', '驳回')
                break
              case 2:
                return h('div', '待办')
                break
            }
          }
        },
        {
          title: '操作',
          key: "Actions",
          align: 'center',
          width: 280,
          render: (h, params) => {
            let disabled = true
            if (this.flowStatus === 1) {
              disabled = false
            }
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.modalTitle = '报表数据'
                    this.flowItemDetail = params.row
                    this.formModal = true
                  }
                }
              }, '报表数据'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small',
                  disabled: disabled
                },
                style: {
                  marginRight: '5px',
                },
                on: {
                  click: () => {
                    this.approvalFlowNext(params)
                  }
                }
              }, '流转'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: disabled
                },
                style: {
                  marginRight: '5px',
                },
                on: {
                  click: () => {
                    this.rejectFlow(params)
                  }
                }
              }, '退回'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: async () => {
                    this.modalTitle = '流程记录'
                    this.flowItemDetail = params.row
                    this.formModal = true
                    // 获取流程详情
                    try {
                      this.user = this.$store.state.session.user
                      let rep = await getFlowHistory(this.$store.state.session.user.phoneNumber, this.flowItemDetail.WorkflowInstanceId)
                      this.flowData = rep
                    } catch (err) {
                      console.error(err)
                      this.flowData = []
                    }
                  }
                }
              }, '流程记录')
            ]);
          }
        },
      ],
      formData: [
        {
          WorkflowTitle: '2342'
        }
      ],
      pageTotal: 1,
      currentPage: 1,
      department: [
        {
          id: 1,
          name: '部门'
        }
      ],
      flowType: '',
      modalTitle: '',
      formModal: false,
      formTitle: '',
      // formDetail: false,
      flowItemDetail: {},
      flowColumns: [
        {
          title: '操作类型',
          key: 'ActivityShowName'
        },
        {
          title: '操作人',
          key: 'RealName',
        },
        {
          title: '执行结果',
          render: (h, params) => {
            let result = '-'
            let resultColor = ''
            switch (params.row.CompletedType) {
              case 'StartWorkflow':
                resultColor = '#19be6b'
                result = '发起'
                break
              case 'Approval':
                resultColor = '#19be6b'
                result = '通过'
                break
              case 'Reject':
                resultColor = '#ed3f14'
                result = '驳回'
                break
              case '':
                resultColor = '#ff9900'
                result = '待办'
                break
            }
            let style = {
              backgroundColor: resultColor,
              borderRadius: '50%',
              width: '6px',
              height: '6px',
              display: 'inline-block',
              marginRight: '5px'
            }
            return (
              <div>
                <div style={style}></div>
                <span>{result}</span>
              </div>
            )
          }
        },
        {
          title: '操作时间',
          render: (h, params) => {
            let time = ''
            if (params.row.CompletedTime) {
              time = parseInt(params.row.CompletedTime.slice(6, 19))
              time = formatDate(time).split(' ')[0]
            }
            return h('div', time)
          }
        },
        {
          title: '备注',
          key: 'Opinion'
        }
      ],
      flowData: [],
      branchVisible: false,
      flowBranch: [],
      branchType: 'next',
      rejectOpinion: '',
      flowPeople: {},
      nextFlowDetail: {},
      flowExtraInfo: {},
      flowStatus: 1,
      flowLine: '线下'
    }
  },
  async created() {
    this.getToDoListData()
    this.search()
  },
  filters: {
    filterTime(val) {
      if (!val) {
        return ''
      }
      let time = parseInt(val.slice(6, 19))
      time = formatDate(time).split(' ')[0]
      return time
    }
  },
  watch: {
    type: {
      async handler(val) {
        this.flowStatus = 1
        this.flowType = val
        if (this.kind === 'scan') {
          this.flowStatus = 2
          this.search()
          return
        }
        this.getToDoListData()
      },
      immediate: true
    },
    flowItemDetail: {
      async handler(val) {
        if (Object.keys(val).length !== 0) {
          this.flowExtraInfo = JSON.parse(val.BusinessKey)
          this.flowLine = this.flowExtraInfo.flowLine ? this.flowExtraInfo.flowLine : '线下'
          this.flowDetailStatus = {
            title: '未知',
            color: '#000'
          }
          switch (val.WorkflowInstanceState) {
            case 3:
              this.flowDetailStatus = {
                title: '成功',
                color: '#19be6b'
              }
              break
            case 5:
              this.flowDetailStatus = {
                title: '驳回',
                color: '#ed3f14'
              }
              break
            case 2:
              this.flowDetailStatus = {
                title: '待办',
                color: '#ff9900'
              }
              break
          }
          // 获取流程详情
          try {
            this.user = this.$store.state.session.user
            let rep = await getFlowHistory(this.$store.state.session.user.phoneNumber, val.WorkflowInstanceId)
            this.flowDetailHistory = rep
          } catch (err) {
            console.error(err)
            this.flowDetailHistory = []
          }
        }
      },
      immediate: true
    },
    kind(val) {
      if (val === 'scan') {
        this.flowStatus = 2
      }
      this.search()
    }
  },
  computed: {
    modalWidth() {
      switch (this.modalTitle) {
        case '流程记录':
        case '流程人员选择':
        case '报表数据':
          return 800
          break
      }
    },
    userPhone() {
      return this.$store.state.session.user.phoneNumber
    }
  },
  methods: {
    async getToDoListData(page = 1) {
      this.currentPage = page
      this.formData = []
      // 获取数据
      try {
        let flowType = this.flowType.indexOf('QR') !== -1 ? 'QR' : this.flowType
        let BusinessKey = this.flowType === 'ZJQR' ? ` and BusinessKey like'%湛江-20%'` : this.flowType === 'ZXQR' ? ` and BusinessKey like'%咨询事业部-20%'` : ''
        let rep = await getToDoList(this.userPhone, { page: page, size: 10, whereStr: `AppId='${flowType}' ${BusinessKey}` })
        this.formData = rep.rows
        this.pageTotal = rep.total
        this.$emit(this.flowType,rep.total)
      } catch (err) {
        console.error(err)
        this.formData = []
      }
    },
    async search(page = 1) {
      this.currentPage = 1
      // let date = this.searchValue.OpenBizDate
      // if (this.searchValue.OpenBizDate) {
      //   date = formatDate(date).split(' ')[0]
      // }
      let flowType = this.type.indexOf('QR') !== -1 ? 'QR' : this.type
      let whereStr = `AppId='${flowType}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
      if (this.type === 'ZJQR') whereStr += ` and BusinessKey like'%湛江-20%'`
      if (this.type === 'ZXQR') whereStr += ` and BusinessKey like'%咨询事业部-20%'`
      let rep = {}
      switch (this.flowStatus) {
        // 待办
        case 1:
          rep = await getToDoList(this.userPhone, { page: page, size: 10, whereStr: whereStr })
          this.$store.commit(`${this.flowType}Count`, rep.total)
          break
        // 进行中
        case 2:
          rep = await getMyWorkItem(this.userPhone, { page: page, size: 10, whereStr: whereStr, isHistory: 0 })
          break
        // 完成
        case 3:
          rep = await getMyWorkItem(this.userPhone, { page: page, size: 10, whereStr: whereStr, isHistory: 1 })
          break
        case 4:
          rep = await getGetDoneList(this.userPhone, { page: page, size: 10, whereStr: whereStr, isHistory: 0 })
          break
        case 5:
          rep = await getGetDoneList(this.userPhone, { page: page, size: 10, whereStr: whereStr, isHistory: 1 })
          break
      }
      this.formData = rep.rows
      this.pageTotal = rep.total
    },
    pageChange(page) {
      this.search(page)
      // this.$refs.flow.pageChange(page)
    },
    // showDetail(title) {
    //   this.formTitle = title
    //   this.formDetail = true
    // },
    async approvalFlowNext(params) {
      this.$Spin.show()
      this.modalTitle = '流程人员选择'
      this.flowItemDetail = params.row
      // 获取流程人员
      try {
        let flowType = this.flowType.indexOf('QR') !== -1 ? 'QR' : this.flowType
        let rep = await getActivityUsers({ appId: flowType, userPhone: this.userPhone, taskId: this.flowItemDetail.TaskId })
        this.$Spin.hide()
        this.branchType = 'next'
        this.flowBranch = rep
        this.branchVisible = true
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('流程人员获取失败')
      }
    },
    async nextFlow() {
      this.$Spin.show()
      this.branchType = 'next'
      let opinion = this.$refs.flowBranch.lastOpinion
      if (this.flowPeople.NextActivityName !== '结束') {
        // 流程转交
        try {
          let processVariablesJson = JSON.stringify([{ key: 'district', value: this.flowExtraInfo.area }])
          let rep = await deliverFlow(this.$store.state.session.user.phoneNumber, { taskId: this.flowItemDetail.TaskId, nextActivityCode: this.flowPeople.NextActivityCode, userId: this.nextFlowDetail.userId, processVariablesJson: processVariablesJson, opinion: opinion })
          this.$Spin.hide()
          this.$refs.flowBranch.lastOpinion = ''
          this.$Message.success('流程流转到下一步')
          this.search()
          this.formModal = false
        } catch (err) {
          console.error(err)
          this.$Spin.hide()
          this.$Message.error('流程转交失败')
        }
      } else {
        // 结束流程
        try {
          let rep = await endFlow(this.$store.state.session.user.phoneNumber, { taskId: this.flowItemDetail.TaskId, nextActivityCode: this.flowPeople.NextActivityCode, opinion: opinion })
          this.$Spin.hide()
          this.$refs.flowBranch.lastOpinion = ''
          this.$Message.success('流程结束成功')
          this.formModal = false
          this.search()
        } catch (err) {
          console.error(err)
          this.$Spin.hide()
          this.$Message.error('流程结束失败')
        } finally {
          // 流程结束，修改状态
          if (this.flowType === 'FP') {
            let date = new Date(this.flowExtraInfo.time)
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            month = ('0' + month).substr(-2, 2)
            date = `${year}-${month}-01`
            ajax.get('/api/services/app/CompanyBonus/GetMonthBonus', {
              params: {
                department: this.flowExtraInfo.area,
                verify: '1',
                date: date
              }
            })
            let messageParams = {
                appId: '1005',
                uniqueId: '刘骁刚', // 用户名
                contentJson: {
                  title: '提成系统',
                  subTitle: '提成发放',
                  description: this.flowExtraInfo.area + date,
                  url: 'http://qy.chinapsp.cn:8884?qyLogin'
                }
              }
            sendMessage('wechat', messageParams)
          }
          if (this.flowType.indexOf('QR') !== -1 && this.flowLine.indexOf('线上') !== -1) {
            let date = new Date(this.flowExtraInfo.time)
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            month = ('0' + month).substr(-2, 2)
            date = `${year}-${month}-01`
            // axios.post(`http://www.choicelink.cn:8888/AgentApi/Orders/UpCwProjects?cwarea=${this.flowExtraInfo.area}&cwmonth=${date}`)
            try {
              axios.put(`https://api.choicelink.cn/NewFinancial/api/services/app/CwProjects/UpdateCwProjects?cwarea=${this.flowExtraInfo.area}&cwmonth=${date}`)
            } catch (err) {
              console.error(err)
            }
            let messageParams = {
              appId: '1005',
              uniqueId: '刘骁刚', // 用户名
              contentJson: {
                title: '提成系统',
                subTitle: '提成申报',
                description: this.flowExtraInfo.area + date,
                url: 'http://qy.chinapsp.cn:8884?qyLogin'
              }
            }
            sendMessage('wechat', messageParams)
          }
          if ((this.flowType.indexOf('QR') !== -1 && this.flowLine.indexOf('线下') !== -1) || this.flowType === 'FQ') {
            let date = new Date(this.flowExtraInfo.time)
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            month = ('0' + month).substr(-2, 2)
            date = `${year}-${month}-01`
            // axios.post(`http://cailian.iplink.com.cn:8088/NeiWebApi/CaiLian/CWUpdate`, {
            ajax.post(`/api/services/app/CompanyBonus/Affirm`, {
              verify: 1,
              verify2: 3,
              a: date,
              dd: date,
              branch: this.flowExtraInfo.company,
              department: this.flowExtraInfo.area,
              dpeditor: this.flowItemDetail.CreatorRealName
            })
            let messageParams = {
              appId: '1005',
              uniqueId: '刘骁刚', // 用户名
              contentJson: {
                title: '提成系统',
                subTitle: '提成申报',
                description: this.flowExtraInfo.area + date,
                url: 'http://qy.chinapsp.cn:8884?qyLogin'
              }
            }
            sendMessage('wechat', messageParams)
          }
        }
      }
    },
    handleFlowNext(nextFlow) {
      this.nextFlowDetail = nextFlow
    },
    async rejectFlow(params) {
      // 获取流程人员
      this.$Spin.show()
      this.flowItemDetail = params.row
      try {
        let rep = await getRejectActivityUsers(this.$store.state.session.user.phoneNumber, this.flowItemDetail.TaskId)
        this.$Spin.hide()
        if (rep.length > 0) {
          this.branchType = 'reject'
          this.flowBranch = rep
          this.branchVisible = true
        } else {
          this.$Message.info('发起人无法退回')
        }
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('退回流程获取失败')
      }
    },
    visibleChange(val) {
      this.branchVisible = val
    },
    branchChoose(val) {
      // this.formModal = true
      // if (this.branchType === 'next') {
      //   // 下一流程人员选择
      //   this.formModal = true
      // }
      this.flowPeople = val
      if (this.branchType === 'reject') {
        // 退回意见输入
        // this.rejectOpinion = ''
        // this.modalTitle = '退回原因'
        // this.formModal = true
        this.rejectFlowConfirm()
        return
      }
      this.branchVisible = false
      this.formModal = true
    },
    async rejectFlowConfirm() {
      let opinion = this.$refs.flowBranch.opinion
      if (!opinion) {
        this.$Message.info('请输入退回原因或意见')
        return
      }
      this.branchVisible = false
      this.$Spin.show()
      try {
        let rep = await rejectFlow(this.$store.state.session.user.phoneNumber, { taskId: this.flowItemDetail.TaskId, activityCode: this.flowPeople.ActivityCode, opinion: opinion })
        this.$Spin.hide()
        this.$Message.success('退回操作成功')
        this.search()
        this.formModal = false
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('退回操作失败')
      }
    },
    statusChange(flowStatus) {
      this.flowStatus = flowStatus
      this.search()
    },
    dataFilter(val) {
      this.formData = val
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.formModal {
  .report {
    button {
      margin-top: 20px;
    }
    button + button {
      margin-left: 10px;
    }
  }
}
// /deep/.formDetail .ivu-modal {
//   top: 20px;
// }
</style>
